export default __webpack_public_path__ + "static/media/result-pere-noel.f89716e2.png";